<template>
    <v-card flat>
        <v-progress-linear :indeterminate="true" v-if="loading"></v-progress-linear>

        <template v-else>
            <v-container>
                <v-card-title>{{ client.name }}</v-card-title>
                <v-card-subtitle class="pb-0">{{ client.cpfcnpj }}</v-card-subtitle>
                <v-divider></v-divider>
                <v-card-text>
                    <v-row>
                        <v-col cols="12" md="6">
                            <v-text-field
                                v-model="client.primaryEmail"
                                label="Email princial"
                                flat
                                readonly
                                disabled
                                hide-details
                            ></v-text-field>
                        </v-col>
                        <v-col cols="12" md="6">
                            <v-text-field
                                v-model="client.commercialPhone"
                                label="Telefone comercial"
                                v-mask="['(##) ####-####', '(##) #####-####']"
                                flat
                                readonly
                                disabled
                                hide-details
                            ></v-text-field>
                        </v-col>
                        <v-col cols="12" md="6">
                            <v-text-field
                                v-model="client.cellPhone"
                                label="Telefone celular"
                                v-mask="['(##) ####-####', '(##) #####-####']"
                                flat
                                readonly
                                disabled
                                hide-details
                            ></v-text-field>
                        </v-col>
                        <v-col cols="12" md="6">
                            <v-switch
                                v-model="client.isActive"
                                :label="`O ${$route.meta.singleName} está ativo? (${((client.isActive) ? 'Sim' : 'Não')})`"
                                flat
                                inset
                                readonly
                            ></v-switch>
                        </v-col>
                        <v-col cols="12">
                            <v-textarea
                                v-model="client.comments"
                                label="Observações"
                                flat
                                readonly
                                disabled
                                hide-details
                                no-resize
                            ></v-textarea>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-container>
        </template>
    </v-card>
</template>

<script>
import API from '@/api'
import { mask } from 'vue-the-mask'

export default {
    name: 'detail-tab-user',
    directives: {
        mask
    },
    data: function () {
        return {
            loading: true,
            mask: {
                cep: '##.###-###'
            },
            collapse: undefined,
            client: {}
        }
    },
    watch: {
        '$route': {
            handler: function (val, oldVal) {
                if (oldVal !== val) {
                    this.loadData()
                }
            },
            deep: true
        }
    },
    mounted () {
        this.loadData()
    },
    computed: {
        birthdayFoundationDateFormated () {
            return this.birthdayFoundationDateNormalize()
        }
    },
    methods: {
        loadData () {
            this.loading = true
            window.getApp.disableClientNavigation = true
            let endpoint = API.EndPoints.getClient
            let params = {
                objectId: this.$route.params.id
            }
            new API(endpoint, params).request().then(response => {
                this.client = Object.assign({}, response.data.result)
                this.loading = false
                window.getApp.disableClientNavigation = false
            }, (e) => {
                this.$helpers.requestError(e)
            })
        },
        birthdayFoundationDateNormalize () {
            return this.$options.filters.momentFormatDate(this.client.birthdayFoundationDate, 'L')
        }
    }
}
</script>
